<div class="wrapper-theme-info">
  <span>{{theme.name}}</span>
  <span class="number-lists">{{theme.lysts_count}} {{theme.lysts_count === 1 ? ('GENERAL.lists' | translate) : ('GENERAL.lists' | translate)}}</span>
</div>
<img [src]="theme.image_url !== null ? theme.image_url : 'assets/images/no-image.png'" alt="">